import Component from '@glimmer/component';

import CButton from 'rise-ui/components/c-button.gjs';
import CIcon from 'rise-ui/components/c-icon.gjs';
import and from 'rise-ui/helpers/and.js';
import not from 'rise-ui/helpers/not.js';

export default class TimeSeriesOutputLinePlotComponent extends Component {
  <template>
    <CButton @type="primary" class="qa-ts-plot" @disabled={{@disabled}} @action={{@onClickPlotButton}}>
      {{#if @isEmpty}}
        <CIcon @icon="graph-empty" />
        No Data
      {{else if @isLoaded}}
        <CIcon @icon="graph-done" />
        Done Plotting Output
      {{else if @loader.error}}
        <CIcon @icon="graph-retry" />
        Retry Plotting
      {{else if (and (not @isLoading) (not @loader.loadedPages))}}
        <CIcon @icon="graph" />
        Plot
      {{else if (not @isLoading)}}
        <CIcon @icon="graph-play" />
        Continue Plotting
      {{else if @isLoading}}
        <CIcon @icon="graph-pause" />
        Pause Plotting
      {{/if}}
    </CButton>
  </template>
}
